import Chart from "chart.js/auto";

export default class {
  constructor(element) {
    const config = {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgba(14, 159, 110)",
              "rgba(227, 160, 8)",
              "rgba(224, 36, 36)",
            ],
          },
        ],
      },
      options: {
        cutout: "70%",
      },
    };

    this.chart = new Chart(element, config);
  }

  update(data) {
    this.chart.data.datasets[0].data = [data.good, data.fair, data.bad];
    this.chart.update();
  }

  destroy() {
    this.chart.destroy();
  }
}
